import { z } from "zod";
import { senhaNovaSchema } from "./senha";

/** Trocar a senha logado: a atual confirma que é a própria pessoa; a nova segue a regra do cadastro. */
export const alterarSenhaSchema = z.object({
  atual: z.string().min(1, "Informe a senha atual"),
  nova: senhaNovaSchema,
});
export type AlterarSenhaInput = z.infer<typeof alterarSenhaSchema>;
